import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import {
  setCommissionRate,
  setGrossCommissionAmount,
  setGrossCommissionPercent,
} from 'bundles/apex/deals/form/store/deal/actions';

import CommissionMode from './mode';
import ManagedFormGroup from 'components/form/managed_input/form_group';
import { propTypes } from 'bundles/apex/deals/form/fields/field';
import * as commissionModes from 'components/lease_structure/form/commission_modes';
import * as leaseStructure from 'bundles/apex/deals/lease_terms/helpers';

export function LeaseDealGrossCommission({
  deal,
  invalid,
  required,
  setCommissionRate,
  setGrossCommissionAmount,
  setGrossCommissionPercent,
}) {
  const amountInput = (
    <ManagedFormGroup
      disabled={leaseStructure.calculatesGrossCommissionAmount(deal)}
      hasError={invalid}
      key="grossCommissionAmount"
      label="Gross Commission $"
      required={required}
      type="currency"
      value={deal.grossCommissionAmount}
      onValueChange={setGrossCommissionAmount}
    />
  );

  const percentInput = (
    <ManagedFormGroup
      disabled={leaseStructure.calculatesGrossCommissionPercent(deal)}
      hasError={invalid}
      key="grossCommissionPercent"
      label="Gross Commission %"
      required={required}
      type="number"
      value={deal.grossCommissionPercent}
      onValueChange={setGrossCommissionPercent}
    />
  );

  const rateInput = (
    <ManagedFormGroup
      disabled={leaseStructure.calculatesCommissionRate(deal)}
      hasError={invalid}
      key="commissionRate"
      label="Commission Rate"
      required={required}
      type="currency"
      value={deal.commissionRate}
      onValueChange={setCommissionRate}
    />
  );

  let inputs;
  if (deal.hasTransactionSides) {
    inputs = [];
  } else if (deal.commissionMode === commissionModes.FLAT_RATE) {
    inputs = [amountInput];
  } else if (
    deal.commissionMode === commissionModes.RATE_PER_SPACE_SIZE_UNIT
      || deal.commissionMode === commissionModes.RATE_PER_SPACE_SIZE_UNIT_PER_MONTH
      || deal.commissionMode === commissionModes.RATE_PER_SPACE_SIZE_UNIT_PER_YEAR
  ) {
    inputs = [rateInput, amountInput];
  } else {
    inputs = [percentInput, amountInput];
  }

  return <React.Fragment>
    <CommissionMode required={required} />
    {inputs}
  </React.Fragment>;
}

LeaseDealGrossCommission.propTypes = {
  ...propTypes,
  setCommissionRate: PropTypes.func.isRequired,
  setGrossCommissionAmount: PropTypes.func.isRequired,
  setGrossCommissionPercent: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  setCommissionRate,
  setGrossCommissionAmount,
  setGrossCommissionPercent,
};

export default connect(null, mapDispatchToProps)(LeaseDealGrossCommission);
